<template>
  <div :class="['container', 'text-link-wrapper', `${page_style}`]" v-if="!hide">
    <p
      @click="goLink"
      class="text-link"
      :style="linkStyle"
    ><span>{{formItem.title}}</span></p>
    <!-- <load-link :src="tmpLink" :show="showLink" @close="closeLink"></load-link> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import loadLink from "./load-link";
import { ends } from "../../tools/constant";
export default {
  components: { loadLink },
  props: ["formItem", "idx", "page_style"],
  data() {
    return { tmpLink: this.formItem.link, showLink: false };
  },
  computed: {
    ...mapState(["_uuid", "_ticket", "_mx_id_no_ab_test"]),
    hide() {
      // @20211123 this.formItem.hide是墨西哥id_no后置新加的input是否可以隐藏的字段,当实验下发true的时候隐藏
      return this.formItem.hide && this._mx_id_no_ab_test;
    },
    linkStyle() {
      return {
        ...(this.formItem.align ? {textAlign: this.formItem.align}: {}),
        ...(this.formItem.color ? {color: this.formItem.color}: {}),
        ...(this.formItem.padding ? {padding: this.formItem.padding}: {}),
      }
    }
  },
  methods: {
    goLink() {
      try {
        if (this.formItem.link.indexOf("99.movida.com.br") > -1) {
          Omega.trackEvent("rent_btn_click", "", {
            duid: this._uuid || new URLSearchParams(location.search).get("uid")
          });
        }
        Fusion.resetBack &&
          Fusion.resetBack({
            reset: 2
          });
        //20200228 vamos设置返回拦截
        Fusion.interceptGoback &&
          Fusion.interceptGoback({ needs_intercept: false }, () => {});
      } catch (e) {
        console.log("try to log error", e);
      }
      let l = this.formItem.link;
      if (this.formItem.is_white) {
        let up = new URLSearchParams(location.search);
        if (this._ticket) {
          up.set("token", this._ticket);
          up.delete("ticket");
        }
        if (l.indexOf("?") > -1) {
          l = `${l}&${up}`;
        } else {
          l = `${l}?${up}`;
        }
      }
      if (ends.inApp) {
        location.href = l;
      } else {
        window.open(l);
      }

      return;
      this.showLink = true;
      this.tmpLink = this.formItem.link;
    },
    closeLink() {
      this.showLink = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.text-link {
  text-align: left;
  color: #FF8040;
  padding: 0;
}
.text-link-wrapper.h5_funnel_fleet,
.text-link-wrapper.h5_funnel_fleet_pc {
  padding: 0 .32rem;
  .text-link > span {
    // width: -webkit-fit-content;
    // width: -moz-fit-content;
    // width: fit-content;
    display: inline-block;
    padding: .12rem .24rem;
    line-height: .32rem;
    background: rgba(255,128,64,0.12);
    border-radius: .32rem;
    color: #FF8040;
    text-align: left;
    font-weight: 500;
  }
}
.text-link-wrapper.h5_funnel_fleet_pc {
  padding: 0 32px;
  .text-link > span {
    padding: 6px 12px;
    font-size: 12px;
  }
}
</style>